import React from 'react';
import { Card } from 'antd';
import AttachMoneyIcon from 'mdi-react/AttachMoneyIcon';
import './Cotacao.scss';

const Cotacao = (): JSX.Element => {
  return (
    <Card
      style={{ width: 150, height: 150 }}
      hoverable
      onClick={
        (): void => {
          window.open('https://www.melhorcambio.com/dolar-hoje', '_blank');
        }
      }
      className="Cotacao"
    >
      <AttachMoneyIcon size={80} className="Cotacao__icon" />
      <Card.Meta title="Cotações" className="Cotacao__title" />
    </Card>
  );
};

Cotacao.propTypes = {};
Cotacao.defaultProps = {};

export default Cotacao;
